import { serverBus } from '@/main';
import { API } from '@/inc/api';

export const stores = {
    namespaced: true,
    state: {
        stores      : [],
        needRefresh : true,
    },
    mutations: {
        setStores( state, payload ) {
            state.stores = payload;
        },
        setNeedRefresh( state, payload ) {
            state.needRefresh = payload;
        }
    },
    actions: {
        async load({ commit, state }) {
            if( !state.needRefresh ) {
                return Promise.resolve();
            }

            try {
                let api = new API();
                let res = await api.get('/admin/stores');

                if( !res.data.status ) {
                    serverBus.$emit('alert', { 
                        text    : res.data.message, 
                        color   : res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject( false );
                }

                commit('setStores', res.data.data);
                commit('setNeedRefresh', false);
                return Promise.resolve();
            }
            catch(error) {
                return Promise.reject(error);
            }
        },
        setNeedRefresh({ commit }, payload) {
            commit('setNeedRefresh', payload);
        }
    },
    getters: {
        stores      : (state) => state.stores,
        needRefresh : (state) => state.needRefresh
    }
}